export default axios => ({
  getList () {
    return axios.get('/questionnaire-list')
  },
  getQuestionnaire (questionnaireId) {
    return axios.get(`/questionnaire-list/${questionnaireId}`)
  },
  update (questionnaireId, payload) {
    return axios.patch(`/questionnaire-list/${questionnaireId}`, payload)
  },
  delete (questionnaireId) {
    return axios.delete(`/questionnaire-list/${questionnaireId}`)
  },
  create (payload) {
    return axios.post('/questionnaire-list', payload)
  }
})
